import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-selected",
  "use": "icon-selected-usage",
  "viewBox": "0 0 16.92 18.46",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.92 18.46\" id=\"icon-selected\">\n  <metadata>\n<x:xmpmeta xmlns:x=\"adobe:ns:meta/\" x:xmptk=\"Adobe XMP Core 5.6-c142 79.160924, 2017/07/13-01:06:39        \">\n   <rdf:RDF xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\">\n      <rdf:Description rdf:about=\"\"></rdf:Description>\n   </rdf:RDF>\n</x:xmpmeta>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</metadata>\n<defs>\n    <style>\n      #icon-selected .cls-1 {\n        fill: none;\n        stroke-width: 0.92px;\n      }\n\n      #icon-selected .cls-2 {\n        font-size: 18px;\n        font-family: \"Microsoft YaHei\";\n      }\n    </style>\n  </defs>\n  <rect id=\"icon-selected_圆角矩形_1888\" data-name=\"圆角矩形 1888\" class=\"cls-1\" x=\"0.46\" y=\"2\" width=\"16\" height=\"16\" rx=\"3\" ry=\"3\" />\n  <text id=\"icon-selected__\" data-name=\"√\" class=\"cls-2\" x=\"1.46\" y=\"15\">√</text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/selected.svg
// module id = 8sK8
// module chunks = 24